// MIGRATED FROM: services/api/v2/wishlist
// MIGRATION DATE: 2024-08-25
// CHANGE TYPE: STANDARD - Solar API implementation with legacy v2 types
// BACKWARD COMPATIBLE: Yes - All existing wishlist methods preserved

import { AxiosInstance } from 'axios'

import { buildApiEndpoint, createSolarApiClient } from '@/shared/libs/api-client'

// Types from services/api/v2/wishlist/types
export type Language = 'ko' | 'ja'
export type Country = 'KR' | 'JP'

export interface WishlistHospital {
  id: number
  customersPick: boolean
  district: string
  statistic: {
    rating: string
    ratingCount: number
    reviewCount: number
    pageCount: number
  }
  images: {
    profileImageUrl: string
  }
  name: string
  certified?: boolean
}

export interface WishlistHospitalResponse {
  currentIndex: number
  lastIndex: number
  pageSize: number
  contents: WishlistHospital[]
}

export interface WishlistHospitalsParam {
  pageIndex: number
  pageSize: number
  sortType?: 'CREATED_DATE'
  orderType?: 'DESC'
}

export class WishlistService {
  constructor(private readonly apiClient: AxiosInstance) {}

  async getWishlistHospitals(userId: number, params: WishlistHospitalsParam): Promise<WishlistHospitalResponse> {
    try {
      const config = buildApiEndpoint(
        {
          method: 'POST',
          url: '/hospital/wish-list/user/queries/get-wish-list/process',
          data: {
            pagination: {
              pageIndex: params.pageIndex,
              pageSize: params.pageSize,
            },
          },
        },
        'solar',
      )

      const response = await this.apiClient.request<WishlistHospitalResponse>(config)
      return response.data
    } catch (error) {
      console.log('error', error)
      throw error
    }
  }

  async addWish(hospitalId: number): Promise<string> {
    const config = buildApiEndpoint(
      {
        method: 'POST',
        url: '/hospital/wish-list/commands/add-wish/execute',
        data: { hospitalId },
      },
      'solar',
    )

    const response = await this.apiClient.request<any>(config)
    return response.data.msgCode || 'SUCCESS'
  }

  async cancelWish(hospitalId: number): Promise<string> {
    const config = buildApiEndpoint(
      {
        method: 'POST',
        url: '/hospital/wish-list/commands/cancel-wish/execute',
        data: { hospitalId },
      },
      'solar',
    )

    const response = await this.apiClient.request<any>(config)
    return response.data.msgCode || 'SUCCESS'
  }

  async hasWish(hospitalId: number): Promise<boolean> {
    const config = buildApiEndpoint(
      {
        method: 'POST',
        url: '/hospital/wish-list/queries/check-if-wish-exists/process',
        data: { hospitalId },
      },
      'solar',
    )

    const response = await this.apiClient.request<{ data: { exists: boolean } }>(config)
    return response.data.data.exists
  }
}

export const clientWishlistService = new WishlistService(createSolarApiClient())
